export default {
  name: 'MainPage',
  data() {
    return {
      menuShow: false,
    };
  },
  methods: {
    activeLink() {
      const body = document.getElementsByTagName('body')[0];
      body.classList.toggle('menu-open');
      this.menuShow = !this.menuShow;
    },
    login() {
      this.$router.push({ name: 'login' });
    },
    register() {
      this.$router.push({ name: 'register' });
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.user;
    },
  },
};
